module.exports = __webpack_public_path__ + "static/media/user.5de51a95.svg";